import React from 'react';

function DotSeparator(): React.JSX.Element {
    return <span className="bg-border size-2 shrink-0 self-center rounded-full" aria-hidden />;
}

export default DotSeparator;
